import type { UsageKind } from "@cmmd-forge/contracts";
import type { KindTotals } from "@cmmd-forge/shared/usageMerge";

/**
 * What the page calls each kind of Usage row.
 *
 * Plural, because every row is a total rather than a single thing, and named
 * the way `CONTEXT.md` section Usage names them.
 */
export const KIND_LABELS: Record<UsageKind, string> = {
  turn: "Turns",
  subagent: "Subagents",
  text_generation: "Text generation",
};

/**
 * Whether the split is worth drawing.
 *
 * Until the emit cards land, every row a fleet reports is a turn, and a table
 * whose other two rows are zero says only that nothing else exists. So the
 * toggle appears the moment subagent or text generation work holds anything at
 * all: cost, tokens, or a record with neither, which is what an Unreported
 * text generation is.
 */
export function shouldShowKindBreakdown(kinds: readonly KindTotals[]): boolean {
  return kinds.some(
    (row) => row.kind !== "turn" && (row.costUsd > 0 || row.totalTokens > 0 || row.records > 0),
  );
}
